module.exports = __webpack_public_path__ + "media/images/thumbs/anatomyphysiology/av430-4679ce799ae16001975de584a33d5e87.jpg";